import React, { useState } from 'react';
import {
  Box,
  Typography,
  List,
  ListItem,
  FormControlLabel,
  Checkbox,
  Button,
  Stack,
} from '@mui/material';

const SetRulesPage = ({ participants, onBack, onGenerate }) => {
  // State: { [participantId]: array av blacklisted participant objects }
  const [blacklists, setBlacklists] = useState({});

  const handleToggle = (participantId, target) => {
    setBlacklists((prev) => {
      const current = prev[participantId] || [];
      let updated;

      if (current.some((p) => p.id === target.id)) {
        updated = current.filter((p) => p.id !== target.id);
      } else {
        updated = [...current, target];
      }

      return { ...prev, [participantId]: updated };
    });
  };

  // ✅ Funktion för att skapa payload till backend
  const generatePayload = () => {
    const payload = {};

    participants.forEach((p) => {
      payload[p.id] = {
        name: p.name,
        blacklist: blacklists[p.id] || [],
      };
    });

    return payload;
  };

  const handleGenerate = () => {
    const payload = generatePayload();
    console.log('Payload att skicka till backend:', payload);

    // Anropa prop-funktionen med payload
    onGenerate(payload);
  };

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        Välj regler för deltagarna
      </Typography>

      {participants.map((p) => (
        <Box
          key={p.id}
          sx={{ mb: 3, border: '1px solid #ccc', borderRadius: 1, p: 2 }}
        >
          <Typography variant="subtitle1" fontWeight="bold">
            {p.name} kan inte ge present till:
          </Typography>
          <List>
            {participants
              .filter((other) => other.id !== p.id)
              .map((other) => {
                const isBlacklisted =
                  blacklists[p.id]?.some((b) => b.id === other.id) || false;

                return (
                  <ListItem key={other.id} dense>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={isBlacklisted}
                          onChange={() => handleToggle(p.id, other)}
                          sx={{
                            color: 'red',
                            '&.Mui-checked': {
                              color: 'red',
                            },
                          }}
                        />
                      }
                      label={
                        <span
                          style={{
                            textDecoration: isBlacklisted
                              ? 'line-through'
                              : 'none',
                          }}
                        >
                          {other.name}
                        </span>
                      }
                    />
                  </ListItem>
                );
              })}
          </List>
        </Box>
      ))}

      {/* Knappar */}
      <Stack direction="row" spacing={2} mt={2}>
        <Button variant="outlined" color="primary" onClick={onBack}>
          Bakåt
        </Button>
        <Button variant="contained" color="secondary" onClick={handleGenerate}>
          Generate Pairings
        </Button>
      </Stack>

      {/* För debug */}
      <pre>{JSON.stringify(generatePayload(), null, 2)}</pre>
    </Box>
  );
};

export default SetRulesPage;
